import { FormControlLabel, Switch, InputLabel, Stack } from '@mui/material';
import React from 'react';

interface SettingBooleanFieldProps {
  value: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  disabled?: boolean;
}

const SettingBooleanField: React.FC<SettingBooleanFieldProps> = ({
  value,
  onChange,
  label = 'Boolean',
  disabled = false,
}) => (
  <Stack
    direction={{ xs: 'column', sm: 'row' }}
    spacing={3}
    alignItems={{ xs: 'stretch', sm: 'center' }}>
    <InputLabel
      sx={{
        minWidth: { xs: 0, sm: 130 },
        color: 'text.primary',
        fontWeight: 500,
        mb: { xs: 1, sm: 0 },
      }}>
      {label}
    </InputLabel>
    <FormControlLabel
      control={<Switch checked={value} onChange={onChange} disabled={disabled} />}
      label=""
      sx={{ m: 0 }}
    />
  </Stack>
);

export default SettingBooleanField;
